exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-import-designer .import-refresh-btn[data-v-571ce959]{margin-top:.75rem}", ""]);

// exports
